<template>
    <div class="left-portion text-center">
        <img class="logo" src="../../../assets/logo.svg" alt="">

        <div class="carousal-section">
           
            <v-carousel cycle hide-delimiter-background :show-arrows="false"  dark active-class="test">
                <v-carousel-item v-for="(slide, index) in carousalData" :key="index" transition="fade-transition">
                    <div >
                        <img :src="slide.image" alt="" style="margin-top:30px !important">
                        <h3 class="--green" style="margin-top:.8rem"> {{ slide.heading }} </h3>
                        <p class="my-0 secondary-font" style="margin-bottom:.8rem"> {{ slide.content }} </p>
                    </div>
                </v-carousel-item>
            </v-carousel>
        </div>

        <!-- <div class="reviews-section mt-2">
            <p class="review">
                Krishify Business managed our brand and helped us
                keeping track of our farmers and retailers
                in a seamless way. Recomended.
            </p>
           <p class="reviewer --weight" style="color : #333333;">Avinash Kumar, Namdhaari</p>
        </div> -->
    </div>
</template>

<script>
export default {
    name : "krishfyPresentation",
    data() {
        return {
            carousalData: [{
                    image: require('../../../assets/FrontPage/Login-carousal-1.svg'),
                    heading: 'Farmer Discovery',
                    content: 'Access to demographic insights about farmers, crop preferences, geographical locations and more'
                },
                {
                    image: require('../../../assets/FrontPage/Login-carousal-2.svg'),
                    heading: 'Market Intelligence and Broadcast',
                    content: 'Get latest trends and insights on cropping pattern and broadcast to farmers through Whatsapp and OBD'
                },
                {
                    image: require('../../../assets/FrontPage/Login-crousal-3.svg'),
                    heading: 'Content Sharing',
                    content: 'Easily share your insightful videos to the farmer community'
                },
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
.logo {
    width: 150px;
    @media (max-width : 1000px)  {
        margin-top:50px;
        
    }
}

@media all and (min-width : 1000px) {
    .left-portion {
        display: block;
        background-color: #F8FAF8;
        padding: 30px 20px 10px;
        width: 40%;
        margin-right: 70px;
        margin-top: 40px;
       // height: 95vh;
    }

   // .carousal-section img {
        //width: 100%;
    //}

    .reviews-section {
        color: #757575;
    }
   
}

@media all and (min-width : 1500px) {
    .left-portion {
        width: 25%;
    }
}
</style>

<style lang="scss">
.carousal-section .mdi-circle {
    color: #D6D6D6 !important;
    opacity: 1 !important;
}

.carousal-section .mdi-circle::before {
    font-size: 8px;
}

.carousal-section .v-carousel__controls__item {
    margin: 0;
    width: 15px;
    margin-top: 20px;
}

.carousal-section .v-carousel {
    height: 400px !important;
}
</style>